import React, { useEffect, useState } from "react";
import "../index.scss";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal
} from "../../../components/commons";
import ExpenseTable from "../../../components/Reports/Grouping/DetailedProfitLoss/ExpenseTable";
import RevenueTable from "../../../components/Reports/Grouping/DetailedProfitLoss/RevenueTable";
import DetailedProfitLossHeader from "../../../components/Reports/Grouping/DetailedProfitLoss/DetailedProfitLossHeader";
import DetailedSubHeader from "../../../components/Reports/Grouping/DetailedProfitLoss/DetailedSubHeader";
import {
  DetailedProfitLossDataType
} from "../../../redux/reports/reportsType";
import {
  GetDetailedProfitLossStatementPayloadType,
  GetProfitLossStatementPayloadType,
} from "../../../commonTypes/reportsTypes";
import { ProfitLossImage } from "../../../assets/images";
import { handleDate, formatDate } from "../../../utils/commonFunctions";
import moment from "moment";
import {
  downloadDetailedProfitAndLossApi
} from "../../../apis/reportsApis";
import FileSaver from "file-saver";
import { Toaster, toast } from "react-hot-toast";
import { connect } from "react-redux";
import {
  getDetailedProfitLossStatementAction,
  resetDetailedProfitLossStatement,
  resetReportsError,
  resetReportsFetching,
  resetReportsSuccess,
} from "../../../redux/reports";
import { resetSession } from "../../../redux/auth";
import { RootState } from "../../../redux/rootReducers";
import SkeltonElement from "../../../components/commons/SkeltonLoader/SkeltonElement";
import ReportFooter from "../../../components/Reports/Grouping/DetailedProfitLoss/ReportFooter";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Excel } from "../../../components/Icon";
import { BranchListType } from "../ProfitLoss";
import { GetAllBussinessAddressesListPayloadType } from "../../../commonTypes/clientSettingsTypes";
import {
  getAllBusinessAddressAction,
  resetBusinessAddressList,
} from "../../../redux/clientSettings";
import { BusinessAddressListType } from "../../../redux/clientSettings/clientSettingTypes";

type AppProps = {
  history?: any;
  token: string | null;
  fetching: boolean;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  currencySign: string | undefined;
  companyName:string;
  businessAddressList: [] | BusinessAddressListType[];
  detailedProfitLossData: DetailedProfitLossDataType;
  dispatchResetSession: () => void;
  dispatchResetReportsErrorAction: () => void;
  dispatchResetReportsSuccessAction: () => void;
  dispatchResetDetailedProfitLossStatementAction: () => void;
  dispatchGetDetailedProfitLossStatementAction: (
    data: GetProfitLossStatementPayloadType
  ) => void;
  dispatchResetReportsFetchingAction: () => void;
  dispatchGetAllBusinessAddressList: (
    data: GetAllBussinessAddressesListPayloadType
  ) => void;
  dispatchResetBusinessAddressList: () => void;
};

const DetailedProfitLoss = ({
  history,
  token,
  fetching,
  businessAddressList,
  error,
  success,
  statusCode,
  currencySign,
  companyName,
  dispatchGetDetailedProfitLossStatementAction,
  dispatchResetDetailedProfitLossStatementAction,
  dispatchResetReportsErrorAction,
  dispatchResetReportsSuccessAction,
  dispatchResetSession,
  detailedProfitLossData,
  dispatchResetReportsFetchingAction,
  dispatchGetAllBusinessAddressList,
  dispatchResetBusinessAddressList,
}: AppProps) => {
  const client_code = history?.location?.state?.client_code;
  const company_name = history?.location?.state?.company_name ? history?.location?.state?.company_name  :  companyName;

  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [displayStartDate, setDisplayStartDate] = useState<string>("");
  const [displayEndDate, setDisplayEndDate] = useState<string>("");
  const [toggle, setToggle] = useState<boolean>(false);
  const [data, setData] = useState<DetailedProfitLossDataType>({
    expenses: [],
    income: [],
    net_profit: 0,
    total_expense: 0,
    total_revenue: 0,
  });
  const [
    isDownloadDetailedProfitLossPresent,
    setIsDownloadDetailedProfitLossPresent,
  ] = useMenuCheck();
  const [isLedgerStatementPresent, setIsLedgerStatementPresent] =
  useMenuCheck();
  const [branchSelected, setBranchSelected] = useState<BranchListType>({
    value: "",
    label: "Select Branch...",
  });
  const [selectedBranchId, setSelectedBranchId] = useState<number | null>(null);
  const [branchName, setBranchName] = useState<string>("");
  const [branchList, setBranchList] = useState<[] | BranchListType[]>([]);

  useEffect(() => {
    setIsDownloadDetailedProfitLossPresent(
      "Download Detailed Profit/Loss Statement",
      "menu"
    );
    setIsLedgerStatementPresent("Ledger Statement", "menu");
    setBranchList([]);
    setBranchName("");
    dispatchResetBusinessAddressList();
    dispatchGetAllBusinessAddressList({ token, client_code });
    dispatchResetReportsErrorAction();
    dispatchResetReportsSuccessAction();
    dispatchResetReportsFetchingAction();
    dispatchResetDetailedProfitLossStatementAction();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setData(detailedProfitLossData);
    (detailedProfitLossData?.expenses?.length > 0 ||
      detailedProfitLossData?.income?.length > 0) &&
      branchSelected?.label !== "Select Branch..."
      ? setBranchName(branchSelected?.label)
      : setBranchName("");
      //eslint-disable-next-line
  }, [detailedProfitLossData]);

  // For Branchwise P & L Data
  useEffect(() => {
    if (businessAddressList && businessAddressList?.length > 0) {
      let finalBranchList: any[] = [];
      businessAddressList?.map((businessAddress: BusinessAddressListType) => {
        finalBranchList.push({
          value: businessAddress?.ledger_id,
          label: businessAddress?.trade_name,
        });
      });

      setBranchList(finalBranchList);
    }
  }, [businessAddressList]);

  useEffect(() => {
    if (displayEndDate != endDate || startDate != displayStartDate) {
      setDisplayStartDate(formatDate(startDate));
      setDisplayEndDate(formatDate(endDate));
    }
    //eslint-disable-next-line
  }, [detailedProfitLossData?.expenses, detailedProfitLossData?.income]);

  const handleStartDateChange = (date: any) => {
    const value = handleDate(date);
    setStartDate(value);
  };

  const handleEndDateChange = (date: any) => {
    const value = handleDate(date);
    setEndDate(value);
  };

  const handleBranchChange = (data: BranchListType) => {
    setSelectedBranchId(+data?.value);
    setBranchSelected(data);
  };

  const handleSubmitData = () => {
    let finalData: GetProfitLossStatementPayloadType = {
      token,
      client_code,
      start_date: formatDate(startDate),
      end_date: formatDate(endDate),
      branch_id: selectedBranchId,
    };

    dispatchGetDetailedProfitLossStatementAction(finalData);
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetReportsErrorAction();
            }}
          />
        );
      }
    }

    return false;
  };

  const finalRedirectLink = {
    pathname: `/reports/${client_code}/ledger-statement?client_code=${client_code}&company_name=${company_name}`,
  };

  const handleDownloadDetailedProfitAndLossStatement = () => {
    let params: GetProfitLossStatementPayloadType = {
      start_date: moment(startDate).format("DD-MM-YYYY"),
      end_date: moment(endDate).format("DD-MM-YYYY"),
      client_code: client_code,
      token,
      branch_id: selectedBranchId,
    };

    if (params && token) {
      handleDownload(params);
    }
  };

  const handleDownload = (params: GetProfitLossStatementPayloadType) => {
    let reportName = company_name
      ? company_name +
      "-" +
      moment(startDate).format("DD-MM-YYYY") +
      " to " +
      moment(endDate).format("DD-MM-YYYY") +
      ".xlsx"
      : "report";
    downloadDetailedProfitAndLossApi(params).then((response: any) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
      });
      FileSaver.saveAs(blob, reportName);
      toast.success("Report Downloaded Successfully!", {
        duration: 3000,
      });
    });
  };

  return (
    <>
      <div className="col-md-6">
        <CommonHeader
          title="Detailed Profit & Loss"
          company_name={company_name}
          client_code={client_code}
        />
      </div>

      <div className="report-card mt-4">
        <div className="inside-report-card">
          <DetailedProfitLossHeader
            setToggle={setToggle}
            toggle={toggle}
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
            handleSubmitData={handleSubmitData}
            handleDownloadDetailedProfitAndLossStatement={
              handleDownloadDetailedProfitAndLossStatement
            }
            data={data}
            isDownloadDetailedProfitLossPresent={
              isDownloadDetailedProfitLossPresent
            }
            branchList={branchList}
            branchSelected={branchSelected}
            handleBranchChange={handleBranchChange}
          />
          <hr className="mt-4 mb-4" style={{ width: "97%" }} />
          {detailedProfitLossData?.expenses?.length == 0 &&
            detailedProfitLossData?.income?.length == 0 &&
            !fetching ? (
            <div className="mt-5 mb-5">
              <EmptyListPage
                title={`No Profit & Loss Statement Found!`}
                text={`Choose start date and end date to get Profit & Loss Statement.`}
                image={ProfitLossImage}
                imageWidth="30%"
              />
            </div>
          ) : (
            <>
              <div className="d-flex">
                <div className='d-flex flex-column mb-3' style={{ flex: "22" }}>
                  <h5 className={"text-center"}>Detailed Profit & Loss Statement</h5>                  <div className="d-flex justify-content-center">
                    <h5>{branchName && `Branch: ${branchName}`}</h5>
                  </div>
                  <div className="d-flex justify-content-center">
                    <h6 className="text-center mr-4">
                      Start Date:{" "}
                      {fetching ? <span><SkeltonElement type='title' /></span> : <span className="font-weight-bolder">
                        {displayStartDate}
                      </span>}
                    </h6>
                    <h6 className="text-center">
                      End Date:{" "}
                      {fetching ? <span><SkeltonElement type='title' /></span> : <span className="font-weight-bolder">{displayEndDate}</span>}
                    </h6>
                  </div>
                </div>
                <div className='d-flex align-items-center mr-2' style={{ flex: "1" }}>
                  {isDownloadDetailedProfitLossPresent &&
                    (!!data?.expenses?.length || !!data?.income?.length) && (
                      <div className="mt-2">
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 250 }}
                          overlay={
                            <Tooltip id="button-view-download-invoice">
                              Download Report
                            </Tooltip>
                          }
                        >
                          {/* <button className="btn form-control" style={{ border: '1px solid #bfcbe1' }} onClick={}><img src={NewDownloadIcon} alt="download icon" /></button> */}
                          <button
                            style={{ border: "none", marginTop: "-6px" }}
                            onClick={
                              handleDownloadDetailedProfitAndLossStatement
                            }
                          >
                            <Excel />
                          </button>
                        </OverlayTrigger>
                      </div>
                    )}
                </div>
              </div>
              <div>
                <DetailedSubHeader subHeading={"INCOME"} />
              </div>

              <RevenueTable
                data={data}
                startDate={startDate}
                endDate={endDate}
                fetching={fetching}
                currencySign={currencySign}
                finalRedirectLink={finalRedirectLink}
                isLedgerStatementPresent={isLedgerStatementPresent}
                selectedBranchId={selectedBranchId}
                branchName={branchName}
              />

              <div>
                <DetailedSubHeader subHeading={"EXPENSES"} />
              </div>
              <ExpenseTable
                fetching={fetching}
                data={data}
                startDate={startDate}
                endDate={endDate}
                currencySign={currencySign}
                finalRedirectLink={finalRedirectLink}
                isLedgerStatementPresent={isLedgerStatementPresent}
                selectedBranchId={selectedBranchId}
                branchName={branchName}
              />

              <ReportFooter data={data} currencySign={currencySign} />
            </>
          )}
        </div>
        {handleErrorModal()}
        <Toaster />
      </div>
    </>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.reports.success,
  fetching: state.reports.fetching,
  error: state.reports.error,
  detailedProfitLossData: state.reports.detailedProfitLossData,
  statusCode: state.reports.statusCode,
  currencySign: state.auth.currencySign,
  companyName: state.auth.companyName,
  businessAddressList: state.clientSettings.businessAddressList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetReportsErrorAction: () => dispatch(resetReportsError()),
  dispatchResetReportsSuccessAction: () => dispatch(resetReportsSuccess()),
  dispatchGetDetailedProfitLossStatementAction: (
    data: GetDetailedProfitLossStatementPayloadType
  ) => dispatch(getDetailedProfitLossStatementAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetReportsFetchingAction: () => dispatch(resetReportsFetching()),
  dispatchResetDetailedProfitLossStatementAction: () =>
    dispatch(resetDetailedProfitLossStatement()),
  dispatchGetAllBusinessAddressList: (
    data: GetAllBussinessAddressesListPayloadType
  ) => dispatch(getAllBusinessAddressAction(data)),
  dispatchResetBusinessAddressList: () => dispatch(resetBusinessAddressList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DetailedProfitLoss);
